import React from 'react'
import './map.styles.css'
function Map() {
    return (
        <div className='map'>
            <iframe title='map' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14018.99440685721!2d77.2547982!3d28.5472752!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xbd3942b2bad0dd93!2sDr.%20Aashima%20Bhalla%2C%20Best%2C%20GOLD%20MEDALIST%20ENT%20Surgeon%20in%20South%20Delhi!5e0!3m2!1sen!2sin!4v1631624236401!5m2!1sen!2sin" width="" height="" style={{ border: '0' }} allowfullscreen="" loading="lazy"></iframe>
        </div>
    )
}

export default Map;
